/** @format */

import { Avatar, Box, ListItemAvatar, ListItemText, Stack, SvgIcon, Typography } from '@mui/material';
import Mail04Icon from '@untitled-ui/icons-react/build/esm/Mail04';

import { get } from 'lodash';
import TypographyTooltip from 'src/components/typography-tooltip';
import { formatDistanceToNow } from 'src/utils/parse';
import CircleColor from '../circle-color';
import LicensePlate from '../license-plate';
import BookingWrapMessage from './booking-wrap-message';
import LicensePlateColor from '../license-plate-color';

const BookingRequestWaitingApprovalNotice = ({ content }) => {
  const updatedAgo = formatDistanceToNow(content.updatedAt, 'trước');
  const requestCar = get(content, 'requestCar');

  return (
    <>
      <ListItemAvatar sx={{ mt: 0.5 }}>
        <Avatar>
          <SvgIcon sx={{ color: 'info.main' }}>
            <Mail04Icon />
          </SvgIcon>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              m: 0
            }}
          >
            <Stack direction="row" columnGap={1} justifyContent="space-between" width="100%">
              <Typography sx={{ mr: 0.5 }} variant="subtitle1">
                {content.tagKey}
              </Typography>
              <Typography variant="caption" color="warning.main">
                {updatedAgo}
              </Typography>
            </Stack>
            {requestCar && (
              <BookingWrapMessage borderColor="warning.main">
                <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                  <Typography variant="body2">Xe :</Typography>
                  <Typography variant="subtitle2" color="primary.main">
                    {requestCar?.model?.name} {` (${requestCar.inServiceYear})`}
                  </Typography>
                </Stack>
                <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                  <Typography variant="body2">Biển số :</Typography>
                  <LicensePlateColor licensePlate={requestCar.licensePlate} color={requestCar.color} />
                </Stack>
              </BookingWrapMessage>
            )}
            <BookingWrapMessage>
              <TypographyTooltip mixText={content.message} maxLines={5} variant="body2" />
            </BookingWrapMessage>
            {/* 
                  <Typography sx={{ mr: 0.5 }} variant="body2">
                    {request.message}
                  </Typography> */}
          </Box>
        }
        primaryTypographyProps={{ component: 'div' }} // Chuyển thẻ <p> thành <div>
        secondaryTypographyProps={{ component: 'div' }}
        sx={{ my: 0 }}
      />
    </>
  );
};

export default BookingRequestWaitingApprovalNotice;
